export function BloodhoundLogo({
  className,
  size = "md",
}: {
  className?: string;
  size?: "sm" | "md" | "lg";
}) {
  const iconSize = size === "lg" ? 40 : size === "sm" ? 24 : 32;
  const textClass =
    size === "lg"
      ? "text-lg"
      : size === "sm"
        ? "text-sm"
        : "text-base";

  return (
    <div className={`flex items-center gap-2.5 ${className ?? ""}`}>
      <img
        src="/icon-mark.png"
        alt=""
        width={iconSize}
        height={iconSize}
        aria-hidden="true"
        className="shrink-0 rounded-md"
        style={{ width: iconSize, height: iconSize }}
      />
      <span className={`text-white font-mono font-bold uppercase tracking-widest ${textClass}`}>
        Bloodhound
      </span>
    </div>
  );
}
